/*
 * @Author: Yandong Hu
 * @github: https://github.com/Mad-hu
 * @Date: 2021-10-09 17:47:15
 * @LastEditTime: 2022-03-22 09:50:59
 * @LastEditors: Yandong Hu
 * @Description:
 */

import { useRecoilState, useSetRecoilState } from "recoil";
import { DEFAULT_EXPORT_NAME } from "../../services/config.service";
import DialogService from "../../services/dialog.service";
import headerService from "../../services/header.service";
import mblockService from "../../services/mblock.service";
import "./header.scss";

export const Header = () => {
  const [getHeaderTextState, setHeaderTextState] = useRecoilState(headerService.HeaderTextState);
  const setDialogRenameBoxVisibleState = useSetRecoilState(DialogService.DialogRenameBoxVisibleState);
  const importProject = () => {
    mblockService.doImport();
  };
  const exportProject = () => {
    setDialogRenameBoxVisibleState(true);
  };
  const newProject = () => {
    setHeaderTextState(DEFAULT_EXPORT_NAME);
    mblockService.doNew();
  };

  return (
    <div className="header-top" id="header">
      <div className="header-l">
        <div className="name" id="projectName" title={getHeaderTextState}>
          {getHeaderTextState}
        </div>
      </div>
      <div className="header-r">
        <div className="btn" onClick={importProject}>
          <div className="load"></div>
          <div className="t">从计算机导入</div>
        </div>
        <div className="btn" onClick={exportProject}>
          <div className="save"></div>
          <div className="t">另存到计算机</div>
        </div>
        <div className="btn" onClick={newProject}>
          <div className="new-p"></div>
          <div className="t">新建</div>
        </div>
      </div>
    </div>
  );
};
